/**
 * Admin GeoCompare (Compare Providers) sidebar configuration.
 *
 * Internal-only admin feature for comparing geogrid scan results across
 * Local Viking, Local Falcon, and Local Dominator.
 */
export default {
  pathPrefix: 'admin/compare_providers',
  items: [
    {
      label: 'New Scan',
      href: '/admin/compare_providers/scan_sessions/new',
      icon: 'fa-solid fa-circle-plus',
      activeUrl: '/admin/compare_providers/scan_sessions/new'
    },
    {
      label: 'All Sessions',
      href: '/admin/compare_providers/scan_sessions',
      icon: 'fa-solid fa-table-list',
      activeUrl: '/admin/compare_providers/scan_sessions',
      activeExact: true
    },
    {
      label: 'Provider Accounts',
      href: '/admin/compare_providers/provider_accounts',
      icon: 'fa-solid fa-key',
      activeUrl: '/admin/compare_providers/provider_accounts'
    },
    {
      label: 'Calibrations',
      href: '/admin/compare_providers/calibrations',
      icon: 'fa-solid fa-sliders',
      activeUrl: '/admin/compare_providers/calibrations'
    }
  ]
}
